"use client"

import styled from "@emotion/styled"
import Link from "next/link"
import React, { memo } from "react"
import type { UrlObject } from "url"

const StyledA = styled.a`
  text-decoration: none;
`

const keepOnlyUtmParams = (search: string): string => {
  if (!search) return ""
  const params = search.split("&")
  return params.filter((param) => param.includes("utm")).join("&")
}

type NextLinkProps = {
  href: string
  passHref?: boolean
  openInNewTab?: boolean
  children: React.ReactNode
  notEncoding?: boolean
  className?: string
}

const NextLink: React.FunctionComponent<NextLinkProps> = ({
  href,
  passHref,
  children,
  openInNewTab = false,
  notEncoding = false,
  className,
}) => {
  // Simplified for App Router - no UTM param preservation for now
  // Can add back with useSearchParams wrapped in Suspense if needed
  const urlWithHash = href.split("#")
  const link: UrlObject = {
    pathname: urlWithHash[0],
    hash: urlWithHash[1] ?? null,
  }

  return (
    <Link href={notEncoding ? href : link} passHref>
      {openInNewTab ? (
        <StyledA target="_blank" rel="noreferrer" className={className}>
          {children}
        </StyledA>
      ) : passHref ? (
        children
      ) : (
        <StyledA>{children}</StyledA>
      )}
    </Link>
  )
}

export default memo(NextLink)
